"use script";

import {onFind} from "@elements/init-modules-in-scope";
import {addClass , findAllIn, findIn, toggleClass, setAttribute, removeAttribute, on} from '@elements/dom-utils';
import { LineChart, AutoScaleAxis } from 'chartist';
import ChartistAxisTitlePlugin from "chartist-plugin-axistitle";
import {
    getConfig,
    isMobile,
} from "./utils";


const selectors = {
    element: '.js-weather-archive',
    form : '.js-weather-archive__form',
    tempError: '.js-weather-archive__temperature-error',
    tempLoading: '.js-weather-archive__temperature-loading',
    tempChartContainer: '.js-weather-archive__temperature',
    tempChart: '.js-weather-archive__temperature-chart',
    tempTimes: '.js-weather-archive__temperature-times',
    windError: '.js-weather-archive__wind-error',
    windLoading: '.js-weather-archive__wind-loading',
    windChartContainer: '.js-weather-archive__wind',
    windChart: '.js-weather-archive__wind-chart' ,
    windTimes: '.js-weather-archive__wind-times',
    datepicker: '.js-datepicker__alt-field',
    fromDate: '.js-datepicker__from-date',
    toDate: '.js-datepicker__to-date',
    boxTitle: '.js-weather-archive-box__title',
    ajaxForm: '.js-ajax-form__form',
};
// rewrite this code in vanilla javascript

export function init() {



    onFind(selectors.element, function (element) {

        findIn('js-weather-archive__form', element)
        let monthLabel;
        onFind(selectors.toDate, function (date) {
            let toDate = new Date((findIn(selectors.datepicker, date).value));
            onFind(selectors.fromDate, function (date) {
                let fromDate = new Date((findIn(selectors.datepicker, date).value));
                monthLabel = getMonthLabel(fromDate, toDate);

            });

        });

        onFind(selectors.form, function (form) {
            on('load', function (){
                console.log('load');
                console.log( findIn('.js-wishlist-filter__submit-btn', form));
                findIn('.js-wishlist-filter__submit-btn', form).click();
            }, window);
            on('fetched.ajax-form', function(evt) {
                evt.preventDefault();
                let result = evt.detail;
                let element = evt.target;
                console.log(result.weatherObject);
                console.log(result.weatherObject);

                onFind(selectors.windChart, function (windChart) {
                    drawGraph(selectors.windChart, monthLabel, element.getAttribute('data-weather-archive-wind-label'), result.weatherObject.wind, selectors.windChartContainer, selectors.windLoading);
                });

                onFind(selectors.tempChart, function (tempChart) {
                    drawGraph(selectors.tempChart, monthLabel, element.getAttribute('data-weather-archive-temperature-label'), result.weatherObject.temperature, selectors.tempChartContainer, selectors.tempLoading);
                });


            }, form);
        });
    });

    function getMonthLabel(fromDate, toDate) {
        let fromMonth = fromDate.toLocaleDateString(getConfig('lang'), {month: 'long'});
        let toMonth = toDate.toLocaleDateString(getConfig('lang'), {month: 'long'});
        return fromMonth === toMonth
            ? fromMonth
            : fromMonth + ' - ' + toMonth
    }
    function timesChangeHandler(item, chart) {
        if(!item.getAttribute('event-listener')) {
            item.setAttribute('event-listener', 'true')
            item.addEventListener('click', function () {
                console.log(item);
                let line = findIn('.' + item.name, chart);
                toggleClass('ct-hidden', line);

            });
        }
    }

    function hideLinesOnLoad(selectedItems, item, chart) {
        if (!selectedItems.includes(item)) {
            let line = findIn('.' + item.name, chart);
            addClass('ct-hidden', line);
        }
    }


    const drawGraph = (domNode, xLabel, yLabel, data, chartContainer, loadingOverlay) => {
        let options = {
            fullWidth: true,
            showArea: false,
            height: 350,
            axisY: {
                onlyInteger: true
            },
            chartPadding: {
                top: 40,
                right: isMobile() ? 50 : 47,
                bottom: isMobile() ? 15 : -80,
                left: isMobile() ? 15 : 25
            },
            plugins: [
                ChartistAxisTitlePlugin({
                    axisX: {
                        axisTitle: xLabel,
                        type: AutoScaleAxis,
                        axisClass: 'ct-axis-title',
                        offset: {
                            x: 0,
                            y: isMobile() ? 25 : 40
                        },
                        textAnchor: 'middle'
                    },
                    axisY: {
                        axisTitle: yLabel,
                        axisClass: 'ct-axis-title',
                        offset: {
                            x: 0,
                            y: isMobile() ? 5 : 0
                        },
                        textAnchor: 'middle',
                        flipTitle: false
                    }
                })
            ]
        };

        let chartWeather = new LineChart(domNode, data, options);

        chartWeather.on("created", function() {

            onFind(chartContainer, function (container) {
                onFind(loadingOverlay, function (loading) {
                    setAttribute('hidden', 'hidden', loading);
                });
                let selectedItems = findAllIn('input[type="checkbox"]:checked', container);
                let items = findAllIn('input[type="checkbox"]', container);
                onFind(domNode, function (chart) {
                    let lines= findAllIn('.ct-series', chart);
                    items.forEach(function (item) {
                        hideLinesOnLoad(selectedItems, item, chart);
                        timesChangeHandler(item, chart)
                    });
                });
            });
        });

        chartWeather.on('draw', function (data) {
            if (data.type === 'line' || data.type === 'area') {
                data.element.animate({
                    d: {
                        begin: 70 * data.index,
                        dur: 220 * Math.pow(.9, data.index),
                        from: data.path.clone().scale(1, 0).translate(0, data.chartRect.height()).stringify(),
                        to: data.path.clone().stringify(),
                        easing: 'easeOutQuint'
                    }
                });
            }
        });

        return data;
    };
}
